import { GetterTree } from "vuex";
import { RootState } from "@/store/types";
import { Log, LogState } from "@/services/logging/types";

export const getters: GetterTree<LogState, RootState> = {
    getLogs(state): Log[] {
        return state.logs;
    }
};
